<div class="rr" *ngIf="resultado">
  <header class="rr-cabecalho">
    <h3>{{ resultado.modelo?.titulo }}</h3>
    <div class="rr-meta">
      <span>{{ resultado.tabela?.qtde | number: '1.0-0':'pt-BR' }} {{ resultado.tabela?.qtde === 1 ? 'linha' : 'linhas' }}</span>
      <span *ngIf="resultado.duracaoMs !== undefined">{{ resultado.duracaoMs / 1000 | number: '1.1-1':'pt-BR' }} s</span>
      <span *ngIf="resultado.empresa?.nome">{{ resultado.empresa.nome }}</span>
    </div>
    <div class="rr-filtros" *ngIf="resultado.filtros?.length">
      <span class="rr-chip" *ngFor="let f of resultado.filtros">{{ f.rotulo }}: <strong>{{ f.texto }}</strong></span>
    </div>
  </header>

  <div class="rr-aviso" *ngIf="resultado.tabela?.truncado">
    O detalhe passou de {{ resultado.tabela.limite | number: '1.0-0':'pt-BR' }} linhas e foi cortado. Subtotais e total geral continuam certos: vêm do banco.
  </div>

  <div class="rr-blocos">
    <ng-container *ngFor="let b of blocos">
      <div class="rr-indicadores" *ngIf="b.bloco === 'indicadores'" [class.rr-metade]="b.largura === 'metade'">
        <div class="rr-indicador" *ngFor="let i of resultado.indicadores">
          <span class="rr-indicador-rotulo">{{ i.rotulo }}</span>
          <span class="rr-indicador-valor">{{ formatarIndicador(i) || '—' }}</span>
        </div>
      </div>

      <section class="rr-cartao rr-grafico" *ngIf="b.bloco === 'grafico'" [class.rr-metade]="b.largura === 'metade'">
        <h4>{{ b.grafico.titulo }}</h4>
        <div class="rr-grafico-area" *ngIf="!b.grafico.vazio">
          <p-chart [type]="b.grafico.tipoChart" [data]="b.grafico.dados" [options]="b.grafico.opcoes" height="260px"></p-chart>
        </div>
        <div class="rr-vazio" *ngIf="b.grafico.vazio">Sem dados com esses filtros.</div>
        <small *ngIf="b.grafico.nota">{{ b.grafico.nota }}</small>
      </section>

      <section class="rr-cartao rr-tabela-cartao" *ngIf="b.bloco === 'tabela'" [class.rr-metade]="b.largura === 'metade'">
        <p-treeTable [value]="nos" styleClass="rr-tabela" [paginator]="nos.length > 25" [rows]="linhasPorPagina" [first]="primeira"
          (onPage)="trocarPagina($event)" [rowsPerPageOptions]="[25, 50, 100]" [showCurrentPageReport]="true"
          [currentPageReportTemplate]="agrupado ? '{first}–{last} de {totalRecords} grupos' : '{first}–{last} de {totalRecords} linhas'">
          <ng-template pTemplate="header">
            <tr>
              <th *ngIf="agrupado" class="rr-col-grupo">{{ tituloGrupo }}</th>
              <th *ngFor="let c of colunasTabela; let primeira = first" [class.direita]="c.direita && (agrupado || !primeira)">{{ c.rotulo }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ngClass]="rowData.grupo ? 'rr-linha-grupo rr-nivel-' + rowData.nivel : ''"
              [class.rr-com-abaixo]="!rowData.grupo && colunasAbaixo.length && linhasAbaixo(rowData.linha).length" [ttRow]="rowNode">
              <td *ngIf="agrupado" class="rr-col-grupo">
                <ng-container *ngIf="rowData.grupo">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <span class="rr-grupo-rotulo">{{ rowData.rotulo }}</span>
                  <span class="rr-grupo-qtde">{{ rowData.qtde | number: '1.0-0':'pt-BR' }}</span>
                  <span class="rr-variavel" *ngFor="let v of rowData.variaveis">{{ v.rotulo }}: <strong>{{ v.texto }}</strong></span>
                </ng-container>
                <span class="rr-arvore-texto" *ngIf="!rowData.grupo && colunaArvore" [style.padding-left.px]="rowData.nivel * 16 + 24"
                  [attr.title]="formatar(rowData.linha[colunaArvore.coluna], colunaArvore)">{{ formatar(rowData.linha[colunaArvore.coluna], colunaArvore) }}</span>
              </td>
              <td *ngFor="let c of colunasTabela; let primeira = first" [class.direita]="c.direita && (agrupado || !primeira)">
                <ng-container *ngIf="rowData.grupo">
                  <ng-container *ngIf="c.total">{{ formatarTotal(rowData.totais[c.coluna], c) }}</ng-container>
                </ng-container>
                <span *ngIf="!rowData.grupo" [attr.title]="c.direita && (agrupado || !primeira) ? null : formatar(rowData.linha[c.coluna], c)">{{ formatar(rowData.linha[c.coluna], c) }}</span>
              </td>
            </tr>
            <ng-container *ngIf="!rowData.grupo && colunasAbaixo.length">
              <tr class="rr-linha-abaixo" *ngFor="let a of linhasAbaixo(rowData.linha); let ultima = last" [class.rr-abaixo-ultima]="ultima">
                <td [attr.colspan]="colunasTabela.length + (agrupado ? 1 : 0)"><div class="rr-abaixo-texto" [style.padding-left.px]="colunaArvore ? rowData.nivel * 16 + 24 : null"><strong>{{ a.rotulo }}:</strong> {{ a.texto }}</div></td>
              </tr>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="footer" *ngIf="totalGeral">
            <tr class="rr-total">
              <td *ngIf="agrupado" class="rr-col-grupo">Total geral<span class="rr-variavel" *ngFor="let v of variaveisTotal">{{ v.rotulo }}: <strong>{{ v.texto }}</strong></span></td>
              <td *ngFor="let c of colunasTabela; let primeira = first" [class.direita]="c.direita">
                <ng-container *ngIf="c.total">{{ formatarTotal(totalGeral[c.coluna], c) }}</ng-container>
                <ng-container *ngIf="!c.total && primeira && !agrupado">Total geral<span class="rr-variavel" *ngFor="let v of variaveisTotal">{{ v.rotulo }}: <strong>{{ v.texto }}</strong></span></ng-container>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="colunasTabela.length + (agrupado ? 1 : 0)" class="rr-vazio">Nenhuma linha com esses filtros.</td>
            </tr>
          </ng-template>
        </p-treeTable>
      </section>
    </ng-container>
  </div>
</div>
